<nrk-window #messageWindow class="message-window" [style]="{ 'width': '40rem', 'min-height': '20rem' }" (onOpen)="onOpen()" (onClose)="onClose()">

  <nrk-header>Messaging</nrk-header>
  
  <nrk-content>

    <div *ngIf="messagingMode === messagingWindowMode.overviewWindow">
      <ng-container *ngTemplateOutlet="messagingOverview"></ng-container>
    </div>

    <div *ngIf="messagingMode === messagingWindowMode.messageWindow && currentMessage?.user" class="message-window">

      <div class="message-header">
        <!-- from -->
        <div [ngClass]="'header-text ' + getClass(currentMessage.user) + '-header'">
          <div>From:</div>
          <div>{{ data.getOptionName(data.userOptions, currentMessage.user)}}</div>
        </div>
        <!-- to -->
        <div [ngClass]="'header-text ' + getClass(currentMessage.recipient) + '-header'">
          <ng-container *ngIf="!this.rootMessage">
            <div>To:</div><div><ngx-doc-form-dropdown [(value)]="currentMessage.recipient" [options]="recipientOptions"></ngx-doc-form-dropdown></div>
          </ng-container>
          <ng-container *ngIf="this.rootMessage">
            <div *ngIf="currentMessage._id">To:</div><div>{{ (currentMessage.recipient && data.getOptionName(data.userOptions, currentMessage.recipient)) || 'All'}}</div>
          </ng-container>
        </div>
        <!-- timestamp -->
        <div class="header-text section">
          <div>On:</div>
          <div>{{ currentMessage.timestamp | date : 'yyyy-MM-dd HH:mm' }}</div>
        </div>
        <!-- doc # -->
        <div class="header-text section">
          <div>Doc:</div>
          <div>{{ currentMessage.code }}</div>
        </div>
        <!-- subject -->
        <div class="message-subject">
          <div class="header-text section">
            <ng-container *ngIf="!this.rootMessage">
              <div>Subject:</div><div style="width:25rem"><ngx-form-text [(value)]="currentMessage.subject" placeholder="Subject" [maxChars]="60"></ngx-form-text></div>
            </ng-container>
            <ng-container *ngIf="this.rootMessage">
              <div>Subject:</div><div>{{ currentMessage.subject }}</div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="messages">
        <div class="main-message">{{currentMessage.message}}</div>
        <ng-container *ngFor="let child of currentMessage.children">
          <div [ngClass]="'child-message ' + getClass(child.user)">
            <div class="child-user">{{ data.userName(child.user) }} [{{child.timestamp | date : 'yyyy-MM-dd HH:mm'}}]
              <ng-container *ngIf="child.deleted"><br>Message deleted by user</ng-container>
            </div>
            <div *ngIf="!child.deleted">
              <ng-container *ngIf="editMessage === child"><ngx-form-text [(value)]="child.message" [multiline]="1" placeholder="Message Text"></ngx-form-text></ng-container>
              <ng-container *ngIf="editMessage !== child">{{ child.message}}</ng-container>
            </div>
            <div *ngIf="mongoId(auth.user) === mongoId(child.user)" class="child-message-buttons">
              <button *ngIf="!child.deleted && editMessage !== child" (click)="editMessage = child">Edit</button>
              <button *ngIf="editMessage === child" (click)="editMessage = null;saveMessage(child)">Save</button>
              <button *ngIf="!child.deleted" (click)="deleteMessage(child)">Delete</button>
            </div>
          </div>
        </ng-container>
      </div>

    </div>

  </nrk-content>

  <nrk-footer>
    <div class="add-message">
      <ngx-form-text [(value)]="currentText" [multiline]="1" placeholder="Message Text"></ngx-form-text>
    </div>
    <div class="footer-buttons">
      <div *ngIf="messagingMode === messagingWindowMode.messageWindow" class="footer-button"><button class="btn btn-sm btn-success" (click)="messageSubmit()">Send</button></div>
      <div class="footer-button"><button class="btn btn-sm btn-info" (click)="messagingMode=messagingWindowMode.messageWindow;show();">New</button></div>
      <div *ngIf="messagingMode === messagingWindowMode.messageWindow && mongoId(auth?.user) === mongoId(rootMessage?.user)" class="footer-button"><button class="btn btn-sm btn-danger" (click)="deleteMessageTree();">Delete</button></div>
      <div *ngIf="messagingMode === messagingWindowMode.messageWindow" class="footer-button"><button class="btn btn-sm btn-info" (click)="update()">Update</button></div>
      <div *ngIf="messagingMode === messagingWindowMode.messageWindow" class="footer-button"><button class="btn btn-sm btn-default" (click)="reloadMessages();messagingMode = messagingWindowMode.overviewWindow">Overview</button></div>
      <div *ngIf="messagingMode === messagingWindowMode.messageWindow" class="footer-button"><button class="btn btn-sm btn-default" (click)="markasReadAndClose()">Close</button></div>
    </div>
  </nrk-footer>

</nrk-window> 


<!-- <nrk-window *ngIf="!messagingWindowType.viewMessage" #messageWindow>
    <nrk-header>Message</nrk-header>
    <nrk-content *ngIf="currentMessage">
      <div class="message-window">
        <p>
          <i style="display:inline-block;width:4rem">From:</i><b>{{ data.getOptionName(data.userOptions, currentMessage.user) }}</b><br>
          <i style="display:inline-block;width:4rem">To:</i><b>{{ (currentMessage.recipient && data.getOptionName(data.userOptions, currentMessage.recipient)) || 'All'}}</b><br>
          <i style="display:inline-block;width:4rem">At:</i>{{ currentMessage.timestamp | date : 'yyyy-MM-dd HH:mm' }}<br>
        </p>
        <p><i style="display:inline-block;width:4rem">Subject:</i><b class="pl-2">{{ currentMessage.subject }}</b></p>
        <p>{{ currentMessage.message }}</p>
      </div>
    </nrk-content>
    <nrk-footer>
      <div style="text-align:center">
        <button class="nrk-button mr-2" (click)="markMessageAsRead(currentMessage)">Mark as Read</button>
        <button class="nrk-button ml-2" (click)="messageWindow.hide()">Close</button>
      </div>
    </nrk-footer>
</nrk-window> -->


<ng-container *ngIf="overviewMode && messages.length">
  <div><b>Messages</b></div>
  <ng-container *ngTemplateOutlet="messagingOverview; context: { fromWindow: false }"></ng-container>
</ng-container>


<ng-template #messagingOverview let-fromWindow="fromWindow">
  <table class="nrk-table w-100 nrk-row-select">
    <thead>
        <tr>
            <th>User</th><th>Subject</th><th>Date</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let message of messages">
            <tr (click)="messagingMode=messagingWindowMode.messageWindow;show(message)">
                <td>{{data.userShort(message.user)}}</td>
                <td>{{message.subject}}</td>
                <td>{{message.timestamp | date : 'yyyy-MM-dd hh:mm'}}</td>
            </tr>
        </ng-container>
    </tbody>
  </table>  
</ng-template>


<!--<nrk-window #messageWindow class="message-window" [style]="{ 'width': '40rem', 'min-height': '20rem' }" (close)="onClose()">

  <nrk-header>Messaging</nrk-header>
  
  <nrk-content>

      <ng-container *ngIf="[messagingWindowType.writeMessage, messagingWindowType.editMessage, messagingWindowType.replyMessage].includes(messagingType)">
        Recipient:
        <ngx-doc-form-dropdown [(value)]="currentMessage.recipient" [options]="recipientOptions"></ngx-doc-form-dropdown>
        <br>
        Subject (max 60 chars):
          <ngx-form-text 
              [(value)]="currentMessage.subject"
              [maxChars]="60"
              [disabled]="messagingType === messagingWindowType.editMessage || messagingType === messagingWindowType.replyMessage || null"
          ></ngx-form-text>
          Message (max 200 chars):
          <ngx-form-text
              [(value)]="currentMessage.message"
              [multiline]="messagingType !== messagingWindowType.replyMessage ? 3 : 10" [maxChars]="200"
              [disabled]="messagingType === messagingWindowType.viewMessage || null"
          ></ngx-form-text>
      </ng-container>

      <ng-container *ngIf="messagingType === messagingWindowType.overviewWindow">
        <ng-container *ngTemplateOutlet="messagingOverview; context: { fromWindow: true }"></ng-container>
      </ng-container>

      <div *ngIf="messagingType === messagingWindowType.viewMessage" class="message-window">
        <div style="display:inline-block;width:50%">
          <p>
            <i class="view-message">From:</i><b>{{ data.userName(currentMessage.user) }}</b><br>
            <i class="view-message">To:</i><b>{{ (currentMessage.recipient && data.userName(currentMessage.recipient)) || 'All'}}</b><br>
            <i class="view-message">On:</i>{{ currentMessage.timestamp | date : 'yyyy-MM-dd HH:mm' }}<br>
          </p>
        </div>
        <div style="display:inline-block;width:calc(50% - 0.5rem);margin-left:0.5rem;overflow-y:auto;height:6rem;position:relative;top:1.5rem;margin-top:-2rem">
          <p style="height:6rem;margin-bottom:-6rem;" *ngIf="currentMessage.isReadBy?.length">
            Read By<br>
            <ng-container *ngFor="let readBy of currentMessage.isReadBy">
              <ng-container *ngIf="readBy.user">{{data.userShort(readBy.user)}} on {{readBy.date | date : 'yy-MM-dd HH:mm' }}<br></ng-container>
            </ng-container>
          </p>
        </div>
        <p><i class="view-message">Subject:</i><b class="pl-2">{{ currentMessage.subject }}</b></p>
        <ng-container *ngFor="let msg of historyMap[currentMessage._id]">
          <p><i>{{ data.userName(msg.user) }} on {{msg.timestamp | date : 'yyyy-MM-dd HH:mm'}}:</i><br>{{ msg.message }}</p>
        </ng-container>
      </div>

  </nrk-content>

  <nrk-footer>

      <ng-container *ngIf="messagingType === messagingWindowType.writeMessage">
          <button
              class="btn btn-md btn-info" 
              (click)="commitMessage();"
              [attr.diabled]="!currentMessage.subject?.length || !currentMessage.message?.length || null"
          >Send</button>
          <button
              class="btn btn-md btn-info"
              (click)="this.currentMessage.subject='';this.currentMessage.message=''"
          >Clear</button>
      </ng-container>

      <ng-container *ngIf="messagingType === messagingWindowType.editMessage">
          <button class="btn btn-md btn-default" (click)="messagingType = messagingWindowType.overviewWindow">Back</button>
          <button class="btn btn-md btn-danger" (click)="deleteMessage(currentMessage)">Delete</button>
          <button class="btn btn-md btn-info" (click)="updateMessage(currentMessage);">Update</button>
      </ng-container>

      <ng-container *ngIf="messagingType === messagingWindowType.overviewWindow">
          <button class="btn btn-md btn-info"
              (click)="newMessage()"
          >New Message</button>
      </ng-container>

      <ng-container *ngIf="messagingType === messagingWindowType.viewMessage">
        <button *ngIf="mongoId(currentMessage.user) === mongoId(auth.user)" class="btn btn-md btn-primary" (click)="messagingType = messagingWindowType.editMessage">Edit</button>
        <button *ngIf="mongoId(currentMessage.user) !== mongoId(auth.user)" class="btn btn-md btn-info" (click)="replyMessage(currentMessage);">Reply</button>
        <button *ngIf="mongoId(currentMessage.user) !== mongoId(auth.user)" class="btn btn-md btn-info" (click)="markMessageAsRead(currentMessage);">Mark as Read</button>
      </ng-container>

      <button
          class="btn btn-md btn-default"
          (click)="messageWindow.hide()"
      >Close</button>

  </nrk-footer>

</nrk-window> 


<!~~ <nrk-window *ngIf="!messagingWindowType.viewMessage" #messageWindow>
    <nrk-header>Message</nrk-header>
    <nrk-content *ngIf="currentMessage">
      <div class="message-window">
        <p>
          <i style="display:inline-block;width:4rem">From:</i><b>{{ data.getOptionName(data.userOptions, currentMessage.user) }}</b><br>
          <i style="display:inline-block;width:4rem">To:</i><b>{{ (currentMessage.recipient && data.getOptionName(data.userOptions, currentMessage.recipient)) || 'All'}}</b><br>
          <i style="display:inline-block;width:4rem">At:</i>{{ currentMessage.timestamp | date : 'yyyy-MM-dd HH:mm' }}<br>
        </p>
        <p><i style="display:inline-block;width:4rem">Subject:</i><b class="pl-2">{{ currentMessage.subject }}</b></p>
        <p>{{ currentMessage.message }}</p>
      </div>
    </nrk-content>
    <nrk-footer>
      <div style="text-align:center">
        <button class="nrk-button mr-2" (click)="markMessageAsRead(currentMessage)">Mark as Read</button>
        <button class="nrk-button ml-2" (click)="messageWindow.hide()">Close</button>
      </div>
    </nrk-footer>
</nrk-window> ~~>


<ng-container *ngIf="overviewMode && messages.length">
  <div><b>Messages</b></div>
  <ng-container *ngTemplateOutlet="messagingOverview; context: { fromWindow: false }"></ng-container>
</ng-container>


<ng-template #messagingOverview let-fromWindow="fromWindow">
  <table class="nrk-table w-100 nrk-row-select">
    <thead>
        <tr>
            <th>User</th><th>Subject</th><th>Date</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let message of messages">
            <tr (click)="setCurrentMessage(message, fromWindow)">
                <td>{{data.userShort(message.user)}}</td>
                <td>{{message.subject}}</td>
                <td>{{message.timestamp | date : 'yyyy-MM-dd hh:mm'}}</td>
            </tr>
        </ng-container>
    </tbody>
  </table>  
</ng-template>

  
-->

